var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1Full(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 164,
    viewBox: "0 0 115 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.3477 135.389V135.889H71.8477H113.936H114.436V135.389V1.41992V0.919922H113.936L87.6309 0.919922H87.5375L87.4503 0.953657L37.4703 20.3068L37.0047 20.4871L37.1844 20.9529L49.2096 52.1435L49.3862 52.6014L49.8473 52.4334L71.3477 44.5985V135.389Z",
    stroke: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8196_4447",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 1,
    width: 77,
    height: 135
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8477 135.389V43.8841L49.6761 51.9636L37.6509 20.7731L87.6309 1.41992L113.936 1.41992V135.389H71.8477Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8196_4447)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8196_4447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.839 1.81202C27.1496 -4.44693 38.7191 -0.463888 44.978 -0.0845315C53.7025 0.547652 72.8585 2.83622 79.6864 6.933C88.2212 12.054 91.2559 31.0203 92.5835 41.8311C93.9111 52.6419 84.997 79.3845 76.8414 83.9364C68.6859 88.4883 51.0472 78.8155 43.6503 69.1426C36.2534 59.4698 48.2022 51.6936 48.7712 49.4176C49.3402 47.1417 49.7195 35.0032 44.978 31.0203C40.2365 27.0373 24.4944 21.7267 17.8561 15.4679C11.2179 9.20896 16.5285 8.07097 21.839 1.81202Z",
    fill: "#3538CD"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2783 80.0326L49.8126 52.6208",
    stroke: "url(#paint0_linear_8196_4447)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 47.4375L36.8075 20.571",
    stroke: "url(#paint1_linear_8196_4447)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6523 27.8708L87.4599 1.00439",
    stroke: "url(#paint2_linear_8196_4447)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2529 72.8907L70.7872 45.479",
    stroke: "url(#paint3_linear_8196_4447)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5947 27.8704L114.402 1.00391",
    stroke: "url(#paint4_linear_8196_4447)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7256 162.767L114.533 135.9",
    stroke: "url(#paint5_linear_8196_4447)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6987 162.515L71.5063 135.648",
    stroke: "url(#paint6_linear_8196_4447)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_8196_4447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0582 162.231V70.7264L13.8866 78.8059L1.86133 47.6154L51.8413 28.2622H78.1466V162.231H36.0582Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5582 162.231V162.731H36.0582H78.1466H78.6466V162.231V28.2622V27.7622H78.1466H51.8413H51.7479L51.6608 27.7959L1.68078 47.1491L1.2152 47.3294L1.3948 47.7952L13.4201 78.9858L13.5966 79.4437L14.0578 79.2757L35.5582 71.4408V162.231Z",
    stroke: "#111517"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8196_4447",
    x: -59.7898,
    y: -76.2297,
    width: 227.054,
    height: 235.873,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.2741,
    result: "effect1_foregroundBlur_8196_4447"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_8196_4447",
    x: -4.79957,
    y: 21.8938,
    width: 89.3145,
    height: 146.706,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.68421
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8196_4447"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8196_4447",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8196_4447",
    x1: 14.4977,
    y1: 80.0325,
    x2: 49.8126,
    y2: 52.6208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8196_4447",
    x1: 2.19517,
    y1: 47.4374,
    x2: 36.8075,
    y2: 20.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8196_4447",
    x1: 52.8475,
    y1: 27.8707,
    x2: 87.4598,
    y2: 1.0044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8196_4447",
    x1: 35.4724,
    y1: 72.8906,
    x2: 70.7872,
    y2: 45.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8196_4447",
    x1: 79.7899,
    y1: 27.8703,
    x2: 114.402,
    y2: 1.00391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8196_4447",
    x1: 79.9208,
    y1: 162.766,
    x2: 114.533,
    y2: 135.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8196_4447",
    x1: 36.8939,
    y1: 162.515,
    x2: 71.5062,
    y2: 135.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Full);
export default __webpack_public_path__ + "static/media/1__full.a731a8a416fbb45c3653f71c1a064672.svg";
export { ForwardRef as ReactComponent };